import { useTranslation } from "react-i18next";

export default function ContactUs() {
  const { t } = useTranslation("contactDigital");

  return (
    <div className="bg-gray-50">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16">
        <div className="mx-auto max-w-2xl divide-y divide-gray-100 lg:mx-0 lg:max-w-none">
          <div className="grid grid-cols-1 gap-10 py-16 lg:grid-cols-2">
            <div>
              <h2 className="text-4xl font-semibold tracking-tight text-pretty text-gray-900">{t("titlePart")}</h2>
              <p className="mt-4 text-base/7 text-gray-600">
                {t("paragraph")}
              </p>
            </div>
            <div className="grid grid-cols-1 gap-6">
              <div className="rounded-2xl bg-white p-10">
                <h3 className="text-base/7 font-semibold text-gray-900">{t("hello")}</h3>
                <dl className="mt-3 space-y-1 text-sm/6 text-gray-600">
                  <div>
                    <dt className="sr-only">Email</dt>
                    <dd>
                      <a href="mailto:info@beehivesud.it" className="font-semibold text-indigo-600">
                        info@beehivesud.it
                      </a>
                    </dd>
                  </div>
                  <div className="mt-1">
                    <dt className="sr-only">Phone number</dt>
                    <dd>
                      <a href="tel:+393384682171" className="font-semibold text-indigo-600">
                        +39 338 4682171
                      </a>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
